import createModel from "../createModel";

export const IncidentsStatistics = createModel("IncidentsStatistics", (json) => ({
    totalIncidentsCount: json.totalIncidentsCount,
    openIncidentsCount: json.openIncidentsCount,
    closedIncidentsCount: json.closedIncidentsCount,
}));
